import { useContractRead, useNetwork } from 'wagmi';
import { getV2Contracts } from '@/config/dex-v3-config';
import { uniswapV2FactoryABI } from '@/config/abis/uniswapV2Factory';

/**
 * Hook to check if a V2 pair exists
 */
export function useV2PoolExists(token0?: string, token1?: string) {
  const { chain } = useNetwork();
  const v2Contracts = chain?.id ? getV2Contracts(chain.id) : null;

  const { data: pairAddress, isLoading } = useContractRead({
    address: v2Contracts?.factory as `0x${string}`,
    abi: uniswapV2FactoryABI,
    functionName: 'getPair',
    args: token0 && token1 ? [token0 as `0x${string}`, token1 as `0x${string}`] : undefined,
    enabled: Boolean(v2Contracts?.factory && token0 && token1),
    watch: true,
  });

  const exists = pairAddress && pairAddress !== '0x0000000000000000000000000000000000000000';

  return {
    exists: Boolean(exists),
    pairAddress: exists ? pairAddress : undefined,
    isLoading,
  };
}
